import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "leftShadow", "rightShadow", "leftShadowSticky", "rightShadowSticky"]

  connect() {
    this.update()
    this.resizeObserver = new ResizeObserver(() => this.update())
    this.resizeObserver.observe(this.containerTarget)
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  update() {
    const container = this.containerTarget
    const isScrollable = container.scrollWidth > container.clientWidth
    const showLeft = container.scrollLeft > 0
    const showRight = container.scrollLeft < (container.scrollWidth - container.clientWidth - 1)

    if (this.hasLeftShadowTarget) {
      if (this.hasLeftShadowStickyTarget) {
        this.leftShadowTarget.style.left = `${this.leftShadowStickyTargets[0].offsetWidth}px`
      }
      this.toggleShadow(this.leftShadowTarget, isScrollable && showLeft)
    }

    if (this.hasRightShadowTarget) {
      if (this.hasRightShadowStickyTarget) {
        this.rightShadowTarget.style.right = `${this.rightShadowStickyTargets[0].offsetWidth}px`
      }
      this.toggleShadow(this.rightShadowTarget, isScrollable && showRight)
    }

    if (this.hasLeftShadowStickyTarget) {
      this.leftShadowStickyTargets.forEach((target) => {
        target.classList.toggle("shadow-[2px_0_8px_-2px_rgba(0,0,0,0.15)]", isScrollable && showLeft)
      })
    }

    if (this.hasRightShadowStickyTarget) {
      this.rightShadowStickyTargets.forEach((target) => {
        target.classList.toggle("shadow-[-2px_0_8px_-2px_rgba(0,0,0,0.15)]", isScrollable && showRight)
      })
    }
  }

  toggleShadow(target, visible) {
    target.classList.toggle("opacity-100", visible)
    target.classList.toggle("opacity-0", !visible)
  }
}
